import { getI18nPropertyValue } from '@/i18n'
import _ from 'lodash'
import moment from 'moment'

export function formatDate (date, _default = '-') {
  if (!date) {
    return _default
  }
  return moment(date).format('YYYY/MM/DD')
}

export function formatDateTime (date, formatter, _default = '-') {
  if (!date) {
    return _default
  }
  if (!formatter) {
    formatter = 'YYYY-MM-DD HH:mm:ss'
  }
  return moment(date).format(formatter)
}

export function formatDistance (distance) {
  if (!distance) {
    return
  }
  if (distance > 100 * 1000) {
    return formatNumber(Math.floor(distance / 1000))
  } else {
    return Math.round(distance / 100) / 10
  }
}

export function formatNumber (number) {
  return !(number + '').includes('.')
    ? (number + '').replace(/\d{1,3}(?=(\d{3})+$)/g, (match) => {
        return match + ','
      })
    : (number + '').replace(/\d{1,3}(?=(\d{3})+(\.))/g, (match) => {
        return match + ','
      })
}

export function formatNotificationCount (count) {
  return formatCount(count, 9)
}

export function formatCount (count, max) {
  if (!count) {
    return
  }
  if (count >= max) {
    return `${max}+`
  } else {
    return count
  }
}

export function formatBigNumber (number, fractionDigits) {
  if (!number) {
    return 0
  }

  if (isNaN(number)) {
    return number
  }

  number = _.toNumber(number)
  if (!_.isInteger(number) && fractionDigits > 0) {
    number = number.toFixed(fractionDigits)
  }

  number += ''
  return number.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

export function formatValue (value, _default = '-') {
  if (!_.trim(value)) {
    return _default
  }
  return value
}

export function formatI18nName (obj, cnPropertyName, enPropertyName, _default = '-') {
  if (!obj) {
    return _default
  }
  return getI18nPropertyValue(obj, cnPropertyName, enPropertyName)
}

export function empty (data, defaultText) {
  if (data === null || data === undefined || data === false) {
    return defaultText || '-'
  } else {
    return data
  }
}
